(function AdvancedCruise($, Adzuki)
{
	"use strict";

	var $modal = $(".modal");

	$(document).ready(function documentReady()
	{
		Adzuki.onload([
			'CruiseSearch/index',
			'CruiseSearch/results',
			'WatchLists/edit',
		], function onload() {
			$('.afc_modify_criteria').click(function afcModifyCriteria() {
				document.location = Adzuki.base_uri + '/CruiseSearch/index';
			});

			// itinerary view
			$('.itinerary-schedule').click(function showItinerary(e) {
				var itinerary_id = $(this).data("itinerary-id");

				e.preventDefault();

				Adzuki.Ajax.get('/Itineraries/details/' + itinerary_id)
					.then(function _updateBookingAgent(html) {
					$modal.addClass('wide');
					$modal.find('.modal-title').text("Itinerary Details");
					$modal.find('.modal-body').html(html);

					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
				});
			});
		});
	});
}(jQuery, window.Adzuki || {}));
